module.exports = __webpack_public_path__ + "img/ley-incencios01.0525e3c9.png";